import styled from 'styled-components'
import { Button } from 'antd'

export const PreviewButton = styled(Button)`
  flex: 0 0 28px;
  width: 28px;
  height: 28px;
  padding: 0;
  margin: 0 3px;
  svg {
    visibility: visible !important;
    color: currentColor !important;
  }
`

export const PreviewBody = styled.div`
  height: min(72vh, 900px);
  min-height: 260px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
  .file-preview-stage {
    flex: 1;
    min-height: 0;
    overflow: auto;
    background: #f5f5f5;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    position: relative;
  }
  .file-preview-center {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    min-height: 180px;
    padding: 16px;
  }
  .file-preview-image {
    display: block;
    margin: auto;
    object-fit: contain;
  }
  video {
    width: 100%;
    height: 100%;
    background: #151515;
  }
  audio {
    width: min(100%, 560px);
  }
  iframe {
    display: block;
    width: 100%;
    height: 100%;
    border: 0;
    background: white;
  }
  pre {
    padding: 20px;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    margin: 0;
  }
  table {
    border-collapse: collapse;
    background: white;
    font-size: 13px;
  }
  td,
  th {
    border: 1px solid #ddd;
    padding: 6px 10px;
    min-width: 80px;
    max-width: 400px;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
  }
  th {
    position: sticky;
    top: 0;
    background: #f0f0f0;
    z-index: 1;
  }
  .file-preview-toolbar {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }
`
